import { AuthenticatorService, IAuthenticatorService } from './authenticator-service';
import { AuthenticateForgotPartialComponent } from './components/authenticate-forgot-partial-component';
import { AuthenticateLoginPartialComponent } from './components/authenticate-login-partial-component';
import { AuthenticatePartialComponent } from './components/authenticate-partial-component';
import { AuthenticateProfilePartialComponent } from './components/authenticate-profile-partial-component';
import { AuthenticateMode, IAuthenticatePartialComponent } from './models';

export class AuthenticateComponent {
  private readonly initialed: boolean = false;
  private readonly rootElement: HTMLElement;
  private readonly loginComponent: IAuthenticatePartialComponent;
  private readonly forgotComponent: IAuthenticatePartialComponent;
  private readonly forgotUnknownComponent: IAuthenticatePartialComponent;
  private readonly forgotSuccessComponent: IAuthenticatePartialComponent;
  private readonly selectProfileComponent: IAuthenticatePartialComponent;
  private readonly authenticator: IAuthenticatorService;

  constructor(rootElement: string | HTMLElement) {
    this.authenticator = new AuthenticatorService();
    if (typeof rootElement === 'string') {
      this.rootElement = document.querySelector(rootElement);
    } else {
      this.rootElement = rootElement;
    }

    if (this.rootElement === null) {
      return;
    }

    this.loginComponent = new AuthenticateLoginPartialComponent(
      this.rootElement.querySelector('.partnernet-login-panel--login') as HTMLElement,
      this.authenticator,
    );
    this.loginComponent.querySelector('.partnernet-login-panel__close').addEventListener(
      'click',
      (): void => {
        this.hide();
      },
    );
    this.loginComponent.querySelector('.partnernet-login-panel__forgotpassword').addEventListener(
      'click',
      (): void => {
        this.loginComponent.hide();
        this.forgotComponent.show();
      },
    );
    this.loginComponent.onSubmit = (mode: AuthenticateMode, ...args: any[]): void => {
      if (mode === undefined) {
        window.location.href = this.getTargetPage();
      } else if (mode === AuthenticateMode.SelectProfile) {
        this.loginComponent.hide();
        this.selectProfileComponent.show.apply(this.selectProfileComponent, args);
      }
    };

    this.forgotComponent = new AuthenticateForgotPartialComponent(
      this.rootElement.querySelector('.partnernet-login-panel--forgot') as HTMLElement,
      this.authenticator,
    );
    this.forgotComponent.querySelector('.partnernet-login-panel__link--return').addEventListener(
      'click',
      (): void => {
        this.forgotComponent.hide();
        this.loginComponent.show();
      },
    );
    this.forgotComponent.onSubmit = (mode: AuthenticateMode): void => {
      this.forgotComponent.hide();
      if (mode === AuthenticateMode.ForgotPasswordSuccess) {
        this.forgotSuccessComponent.show();
      } else {
        this.forgotUnknownComponent.show();
      }
    };

    this.forgotUnknownComponent = new AuthenticatePartialComponent(
      this.rootElement.querySelector('.partnernet-login-panel--forgot-unknown') as HTMLElement,
      this.authenticator,
    );
    this.forgotUnknownComponent.querySelector('.partnernet-login-panel__link--return').addEventListener(
      'click',
      (): void => {
        this.forgotUnknownComponent.hide();
        this.forgotComponent.show();
      },
    );

    this.forgotSuccessComponent = new AuthenticatePartialComponent(
      this.rootElement.querySelector('.partnernet-login-panel--forgot-success') as HTMLElement,
      this.authenticator,
    );
    this.forgotSuccessComponent.querySelector('.partnernet-login-panel__link--return').addEventListener(
      'click',
      (): void => {
        this.forgotSuccessComponent.hide();
        this.loginComponent.show();
      },
    );

    this.selectProfileComponent = new AuthenticateProfilePartialComponent(
      this.rootElement.querySelector('.partnernet-login-panel--select-profile') as HTMLElement,
      this.authenticator,
    );
    this.selectProfileComponent.onSubmit = (mode: AuthenticateMode): void => {
      window.location.href = this.getTargetPage();
    };
  }

  public show(): void {
    if (this.rootElement === null) {
      return;
    }

    this.rootElement.style.display = 'block';
    if (!this.initialed) {
      this.loginComponent.show();
    }
  }

  public hide(): void {
    if (this.rootElement === null) {
      return;
    }

    this.rootElement.style.display = 'none';
  }

  public toggle(): void {
    if (this.rootElement === null) {
      return;
    }

    const currentState = this.rootElement.style.display;
    if (currentState === 'none') {
      this.show();
    } else {
      this.hide();
    }
  }

  public getReturnUrlFrom(key: string, querystring: string): string {
    const regex = new RegExp('[\\?&#]' + key + '=([^&#]*)');

    const results: RegExpExecArray = regex.exec(querystring);
    if (!results || results.length <= 0) {
      return undefined;
    }

    const url: string = decodeURIComponent(results[1].replace(/\+/g, ' '));

    return url;
  }

  private getTargetPage(): string {
    const targetPage: string = this.rootElement.dataset.successPageRedirect;
    return (
      this.getReturnUrlFrom('returnUrl', window.location.search) ||
      this.getReturnUrlFrom('url', window.location.hash) ||
      targetPage
    );
  }
}
